// Generated from AioExpressionLexer.g4 by ANTLR 4.13.1
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import { ATNDeserializer, DFA, Lexer, LexerATNSimulator, PredictionContextCache, Token, } from 'antlr4';
export default class AioExpressionLexer extends Lexer {
    static DYNAMIC_START = 1;
    static TEXT = 2;
    static DYNAMIC_END = 3;
    static FORMAT_NUMBER_DIGITS = 4;
    static DISPLAY_IF = 5;
    static SUBSTRING = 6;
    static ADD = 7;
    static SUB = 8;
    static MUL = 9;
    static DIV = 10;
    static MOD = 11;
    static LT = 12;
    static LTE = 13;
    static GT = 14;
    static GTE = 15;
    static OR = 16;
    static AND = 17;
    static NOT = 18;
    static EQUALS = 19;
    static NOT_EQUALS = 20;
    static E_C_NAME = 21;
    static E_C_T_NAME = 22;
    static E_C_P_NAME = 23;
    static EM_SPECIFIER = 24;
    static EM_C_NAME = 25;
    static EM_C_T_NAME = 26;
    static EM_C_P_NAME = 27;
    static EMO_SPECIFIER = 28;
    static EMO_C_NAME = 29;
    static EMO_C_T_NAME = 30;
    static EMO_C_P_NAME = 31;
    static NUMBER = 32;
    static WS = 33;
    static COMMA = 34;
    static ASSIGN = 35;
    static SEMICOLON = 36;
    static SINGLE_QUOTE = 37;
    static DOUBLE_QUOTE = 38;
    static SQUARE_BRACKET_OPEN = 39;
    static SQUARE_BRACKET_CLOSE = 40;
    static PARENTHESIS_OPEN = 41;
    static PARENTHESIS_CLOSE = 42;
    static STRING = 43;
    static EOF = Token.EOF;
    static DYNAMIC = 1;
    static channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];
    static literalNames = [
        null,
        "'{{'",
        null,
        "'}}'",
        "'FORMAT_NUMBER_DIGITS'",
        "'DISPLAY_IF'",
        "'SUBSTRING'",
        "'+'",
        "'-'",
        "'*'",
        "'/'",
        "'%'",
        "'<'",
        "'<='",
        "'>'",
        "'>='",
        "'||'",
        "'&&'",
        "'!'",
        "'=='",
        "'!='",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        "','",
        "'='",
        "';'",
        "'''",
        "'\"'",
        "'['",
        "']'",
        "'('",
        "')'",
    ];
    static symbolicNames = [
        null,
        'DYNAMIC_START',
        'TEXT',
        'DYNAMIC_END',
        'FORMAT_NUMBER_DIGITS',
        'DISPLAY_IF',
        'SUBSTRING',
        'ADD',
        'SUB',
        'MUL',
        'DIV',
        'MOD',
        'LT',
        'LTE',
        'GT',
        'GTE',
        'OR',
        'AND',
        'NOT',
        'EQUALS',
        'NOT_EQUALS',
        'E_C_NAME',
        'E_C_T_NAME',
        'E_C_P_NAME',
        'EM_SPECIFIER',
        'EM_C_NAME',
        'EM_C_T_NAME',
        'EM_C_P_NAME',
        'EMO_SPECIFIER',
        'EMO_C_NAME',
        'EMO_C_T_NAME',
        'EMO_C_P_NAME',
        'NUMBER',
        'WS',
        'COMMA',
        'ASSIGN',
        'SEMICOLON',
        'SINGLE_QUOTE',
        'DOUBLE_QUOTE',
        'SQUARE_BRACKET_OPEN',
        'SQUARE_BRACKET_CLOSE',
        'PARENTHESIS_OPEN',
        'PARENTHESIS_CLOSE',
        'STRING',
    ];
    static modeNames = ['DEFAULT_MODE', 'DYNAMIC'];
    static ruleNames = [
        'DYNAMIC_START',
        'TEXT',
        'DYNAMIC_END',
        'FORMAT_NUMBER_DIGITS',
        'DISPLAY_IF',
        'SUBSTRING',
        'ADD',
        'SUB',
        'MUL',
        'DIV',
        'MOD',
        'LT',
        'LTE',
        'GT',
        'GTE',
        'OR',
        'AND',
        'NOT',
        'EQUALS',
        'NOT_EQUALS',
        'E_C_NAME',
        'E_C_T_NAME',
        'E_C_P_NAME',
        'EM_SPECIFIER',
        'EM_C_NAME',
        'EM_C_T_NAME',
        'EM_C_P_NAME',
        'EMO_SPECIFIER',
        'EMO_C_NAME',
        'EMO_C_T_NAME',
        'EMO_C_P_NAME',
        'NUMBER',
        'WS',
        'COMMA',
        'ASSIGN',
        'SEMICOLON',
        'SINGLE_QUOTE',
        'DOUBLE_QUOTE',
        'SQUARE_BRACKET_OPEN',
        'SQUARE_BRACKET_CLOSE',
        'PARENTHESIS_OPEN',
        'PARENTHESIS_CLOSE',
        'STRING',
        'SPECIFIER',
        'ORDINAL',
        'DIGIT',
    ];
    constructor(input) {
        super(input);
        this._interp = new LexerATNSimulator(this, AioExpressionLexer._ATN, AioExpressionLexer.DecisionsToDFA, new PredictionContextCache());
    }
    get grammarFileName() {
        return 'AioExpressionLexer.g4';
    }
    get literalNames() {
        return AioExpressionLexer.literalNames;
    }
    get symbolicNames() {
        return AioExpressionLexer.symbolicNames;
    }
    get ruleNames() {
        return AioExpressionLexer.ruleNames;
    }
    get serializedATN() {
        return AioExpressionLexer._serializedATN;
    }
    get channelNames() {
        return AioExpressionLexer.channelNames;
    }
    get modeNames() {
        return AioExpressionLexer.modeNames;
    }
    static _serializedATN = [
        4, 0, 43, 374, 6, -1, 6, -1, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5,
        7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12,
        2, 13, 7, 13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7,
        19, 2, 20, 7, 20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25, 7, 25, 2, 26,
        7, 26, 2, 27, 7, 27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7, 31, 2, 32, 7, 32, 2,
        33, 7, 33, 2, 34, 7, 34, 2, 35, 7, 35, 2, 36, 7, 36, 2, 37, 7, 37, 2, 38, 7, 38, 2, 39, 7, 39,
        2, 40, 7, 40, 2, 41, 7, 41, 2, 42, 7, 42, 2, 43, 7, 43, 2, 44, 7, 44, 2, 45, 7, 45, 1, 0, 1, 0,
        1, 0, 1, 0, 1, 0, 1, 1, 4, 1, 101, 8, 1, 11, 1, 12, 1, 102, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3,
        1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3,
        1, 3, 1, 3, 1, 3, 1, 3, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 5,
        1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 6, 1, 6, 1, 7, 1, 7, 1, 8, 1, 8, 1, 9,
        1, 9, 1, 10, 1, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 12, 1, 13, 1, 13, 1, 14, 1, 14, 1, 14, 1, 15,
        1, 15, 1, 15, 1, 16, 1, 16, 1, 16, 1, 17, 1, 17, 1, 18, 1, 18, 1, 18, 1, 19, 1, 19, 1, 19, 1,
        20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 21, 1, 21, 1, 21,
        1, 21, 1, 21, 1, 21, 1, 21, 1, 21, 1, 21, 1, 21, 1, 21, 1, 21, 1, 21, 1, 22, 1, 22, 1, 22, 1,
        22, 1, 22, 1, 22, 1, 22, 1, 22, 1, 22, 1, 22, 1, 22, 1, 22, 1, 22, 1, 23, 1, 23, 1, 23, 1, 23,
        1, 23, 1, 23, 1, 23, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1,
        24, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25,
        1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1,
        27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28,
        1, 28, 1, 28, 1, 28, 1, 28, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1, 29, 1,
        29, 1, 29, 1, 29, 1, 29, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30, 1, 30,
        1, 30, 1, 30, 1, 30, 1, 31, 3, 31, 312, 8, 31, 1, 31, 4, 31, 315, 8, 31, 11, 31, 12, 31, 316, 1,
        31, 1, 31, 4, 31, 321, 8, 31, 11, 31, 12, 31, 322, 3, 31, 325, 8, 31, 1, 32, 4, 32, 328, 8, 32,
        11, 32, 12, 32, 329, 1, 32, 1, 32, 1, 33, 1, 33, 1, 34, 1, 34, 1, 35, 1, 35, 1, 36, 1, 36, 1,
        37, 1, 37, 1, 38, 1, 38, 1, 39, 1, 39, 1, 40, 1, 40, 1, 41, 1, 41, 1, 42, 1, 42, 5, 42, 354, 8,
        42, 10, 42, 12, 42, 357, 9, 42, 1, 42, 1, 42, 1, 43, 4, 43, 362, 8, 43, 11, 43, 12, 43, 363, 1,
        44, 1, 44, 5, 44, 368, 8, 44, 10, 44, 12, 44, 371, 9, 44, 1, 45, 1, 45, 0, 0, 46, 2, 1, 4, 2, 6,
        3, 8, 4, 10, 5, 12, 6, 14, 7, 16, 8, 18, 9, 20, 10, 22, 11, 24, 12, 26, 13, 28, 14, 30, 15, 32,
        16, 34, 17, 36, 18, 38, 19, 40, 20, 42, 21, 44, 22, 46, 23, 48, 24, 50, 25, 52, 26, 54, 27, 56,
        28, 58, 29, 60, 30, 62, 31, 64, 32, 66, 33, 68, 34, 70, 35, 72, 36, 74, 37, 76, 38, 78, 39, 80,
        40, 82, 41, 84, 42, 86, 43, 88, 0, 90, 0, 92, 0, 2, 0, 1, 6, 2, 0, 123, 123, 125, 125, 3, 0, 9,
        10, 13, 13, 32, 32, 3, 0, 10, 10, 13, 13, 34, 34, 3, 0, 48, 57, 65, 90, 95, 95, 1, 0, 49, 57, 1,
        0, 48, 57, 378, 0, 2, 1, 0, 0, 0, 0, 4, 1, 0, 0, 0, 1, 6, 1, 0, 0, 0, 1, 8, 1, 0, 0, 0, 1, 10,
        1, 0, 0, 0, 1, 12, 1, 0, 0, 0, 1, 14, 1, 0, 0, 0, 1, 16, 1, 0, 0, 0, 1, 18, 1, 0, 0, 0, 1, 20,
        1, 0, 0, 0, 1, 22, 1, 0, 0, 0, 1, 24, 1, 0, 0, 0, 1, 26, 1, 0, 0, 0, 1, 28, 1, 0, 0, 0, 1, 30,
        1, 0, 0, 0, 1, 32, 1, 0, 0, 0, 1, 34, 1, 0, 0, 0, 1, 36, 1, 0, 0, 0, 1, 38, 1, 0, 0, 0, 1, 40,
        1, 0, 0, 0, 1, 42, 1, 0, 0, 0, 1, 44, 1, 0, 0, 0, 1, 46, 1, 0, 0, 0, 1, 48, 1, 0, 0, 0, 1, 50,
        1, 0, 0, 0, 1, 52, 1, 0, 0, 0, 1, 54, 1, 0, 0, 0, 1, 56, 1, 0, 0, 0, 1, 58, 1, 0, 0, 0, 1, 60,
        1, 0, 0, 0, 1, 62, 1, 0, 0, 0, 1, 64, 1, 0, 0, 0, 1, 66, 1, 0, 0, 0, 1, 68, 1, 0, 0, 0, 1, 70,
        1, 0, 0, 0, 1, 72, 1, 0, 0, 0, 1, 74, 1, 0, 0, 0, 1, 76, 1, 0, 0, 0, 1, 78, 1, 0, 0, 0, 1, 80,
        1, 0, 0, 0, 1, 82, 1, 0, 0, 0, 1, 84, 1, 0, 0, 0, 1, 86, 1, 0, 0, 0, 2, 94, 1, 0, 0, 0, 4, 100,
        1, 0, 0, 0, 6, 104, 1, 0, 0, 0, 8, 109, 1, 0, 0, 0, 10, 130, 1, 0, 0, 0, 12, 141, 1, 0, 0, 0,
        14, 151, 1, 0, 0, 0, 16, 153, 1, 0, 0, 0, 18, 155, 1, 0, 0, 0, 20, 157, 1, 0, 0, 0, 22, 159, 1,
        0, 0, 0, 24, 161, 1, 0, 0, 0, 26, 163, 1, 0, 0, 0, 28, 166, 1, 0, 0, 0, 30, 168, 1, 0, 0, 0, 32,
        171, 1, 0, 0, 0, 34, 174, 1, 0, 0, 0, 36, 177, 1, 0, 0, 0, 38, 179, 1, 0, 0, 0, 40, 182, 1, 0,
        0, 0, 42, 185, 1, 0, 0, 0, 44, 196, 1, 0, 0, 0, 46, 209, 1, 0, 0, 0, 48, 222, 1, 0, 0, 0, 50,
        229, 1, 0, 0, 0, 52, 240, 1, 0, 0, 0, 54, 253, 1, 0, 0, 0, 56, 266, 1, 0, 0, 0, 58, 273, 1, 0,
        0, 0, 60, 284, 1, 0, 0, 0, 62, 297, 1, 0, 0, 0, 64, 311, 1, 0, 0, 0, 66, 327, 1, 0, 0, 0, 68,
        333, 1, 0, 0, 0, 70, 335, 1, 0, 0, 0, 72, 337, 1, 0, 0, 0, 74, 339, 1, 0, 0, 0, 76, 341, 1, 0,
        0, 0, 78, 343, 1, 0, 0, 0, 80, 345, 1, 0, 0, 0, 82, 347, 1, 0, 0, 0, 84, 349, 1, 0, 0, 0, 86,
        351, 1, 0, 0, 0, 88, 361, 1, 0, 0, 0, 90, 365, 1, 0, 0, 0, 92, 372, 1, 0, 0, 0, 94, 95, 5, 123,
        0, 0, 95, 96, 5, 123, 0, 0, 96, 97, 1, 0, 0, 0, 97, 98, 6, 0, 0, 0, 98, 3, 1, 0, 0, 0, 99, 101,
        8, 0, 0, 0, 100, 99, 1, 0, 0, 0, 101, 102, 1, 0, 0, 0, 102, 100, 1, 0, 0, 0, 102, 103, 1, 0, 0,
        0, 103, 5, 1, 0, 0, 0, 104, 105, 5, 125, 0, 0, 105, 106, 5, 125, 0, 0, 106, 107, 1, 0, 0, 0,
        107, 108, 6, 2, 1, 0, 108, 7, 1, 0, 0, 0, 109, 110, 5, 70, 0, 0, 110, 111, 5, 79, 0, 0, 111,
        112, 5, 82, 0, 0, 112, 113, 5, 77, 0, 0, 113, 114, 5, 65, 0, 0, 114, 115, 5, 84, 0, 0, 115, 116,
        5, 95, 0, 0, 116, 117, 5, 78, 0, 0, 117, 118, 5, 85, 0, 0, 118, 119, 5, 77, 0, 0, 119, 120, 5,
        66, 0, 0, 120, 121, 5, 69, 0, 0, 121, 122, 5, 82, 0, 0, 122, 123, 5, 95, 0, 0, 123, 124, 5, 68,
        0, 0, 124, 125, 5, 73, 0, 0, 125, 126, 5, 71, 0, 0, 126, 127, 5, 73, 0, 0, 127, 128, 5, 84, 0,
        0, 128, 129, 5, 83, 0, 0, 129, 9, 1, 0, 0, 0, 130, 131, 5, 68, 0, 0, 131, 132, 5, 73, 0, 0, 132,
        133, 5, 83, 0, 0, 133, 134, 5, 80, 0, 0, 134, 135, 5, 76, 0, 0, 135, 136, 5, 65, 0, 0, 136, 137,
        5, 89, 0, 0, 137, 138, 5, 95, 0, 0, 138, 139, 5, 73, 0, 0, 139, 140, 5, 70, 0, 0, 140, 11, 1, 0,
        0, 0, 141, 142, 5, 83, 0, 0, 142, 143, 5, 85, 0, 0, 143, 144, 5, 66, 0, 0, 144, 145, 5, 83, 0,
        0, 145, 146, 5, 84, 0, 0, 146, 147, 5, 82, 0, 0, 147, 148, 5, 73, 0, 0, 148, 149, 5, 78, 0, 0,
        149, 150, 5, 71, 0, 0, 150, 13, 1, 0, 0, 0, 151, 152, 5, 43, 0, 0, 152, 15, 1, 0, 0, 0, 153,
        154, 5, 45, 0, 0, 154, 17, 1, 0, 0, 0, 155, 156, 5, 42, 0, 0, 156, 19, 1, 0, 0, 0, 157, 158, 5,
        47, 0, 0, 158, 21, 1, 0, 0, 0, 159, 160, 5, 37, 0, 0, 160, 23, 1, 0, 0, 0, 161, 162, 5, 60, 0,
        0, 162, 25, 1, 0, 0, 0, 163, 164, 5, 60, 0, 0, 164, 165, 5, 61, 0, 0, 165, 27, 1, 0, 0, 0, 166,
        167, 5, 62, 0, 0, 167, 29, 1, 0, 0, 0, 168, 169, 5, 62, 0, 0, 169, 170, 5, 61, 0, 0, 170, 31, 1,
        0, 0, 0, 171, 172, 5, 124, 0, 0, 172, 173, 5, 124, 0, 0, 173, 33, 1, 0, 0, 0, 174, 175, 5, 38,
        0, 0, 175, 176, 5, 38, 0, 0, 176, 35, 1, 0, 0, 0, 177, 178, 5, 33, 0, 0, 178, 37, 1, 0, 0, 0,
        179, 180, 5, 61, 0, 0, 180, 181, 5, 61, 0, 0, 181, 39, 1, 0, 0, 0, 182, 183, 5, 33, 0, 0, 183,
        184, 5, 61, 0, 0, 184, 41, 1, 0, 0, 0, 185, 186, 5, 69, 0, 0, 186, 187, 5, 46, 0, 0, 187, 188,
        5, 67, 0, 0, 188, 189, 1, 0, 0, 0, 189, 190, 3, 90, 44, 0, 190, 191, 5, 46, 0, 0, 191, 192, 5,
        78, 0, 0, 192, 193, 5, 65, 0, 0, 193, 194, 5, 77, 0, 0, 194, 195, 5, 69, 0, 0, 195, 43, 1, 0, 0,
        0, 196, 197, 5, 69, 0, 0, 197, 198, 5, 46, 0, 0, 198, 199, 5, 67, 0, 0, 199, 200, 1, 0, 0, 0,
        200, 201, 3, 90, 44, 0, 201, 202, 5, 46, 0, 0, 202, 203, 5, 84, 0, 0, 203, 204, 5, 46, 0, 0,
        204, 205, 5, 78, 0, 0, 205, 206, 5, 65, 0, 0, 206, 207, 5, 77, 0, 0, 207, 208, 5, 69, 0, 0, 208,
        45, 1, 0, 0, 0, 209, 210, 5, 69, 0, 0, 210, 211, 5, 46, 0, 0, 211, 212, 5, 67, 0, 0, 212, 213,
        1, 0, 0, 0, 213, 214, 3, 90, 44, 0, 214, 215, 5, 46, 0, 0, 215, 216, 5, 80, 0, 0, 216, 217, 5,
        46, 0, 0, 217, 218, 5, 78, 0, 0, 218, 219, 5, 65, 0, 0, 219, 220, 5, 77, 0, 0, 220, 221, 5, 69,
        0, 0, 221, 47, 1, 0, 0, 0, 222, 223, 5, 77, 0, 0, 223, 224, 5, 46, 0, 0, 224, 225, 5, 83, 0, 0,
        225, 226, 5, 46, 0, 0, 226, 227, 1, 0, 0, 0, 227, 228, 3, 88, 43, 0, 228, 49, 1, 0, 0, 0, 229,
        230, 5, 77, 0, 0, 230, 231, 5, 46, 0, 0, 231, 232, 5, 67, 0, 0, 232, 233, 1, 0, 0, 0, 233, 234,
        3, 90, 44, 0, 234, 235, 5, 46, 0, 0, 235, 236, 5, 78, 0, 0, 236, 237, 5, 65, 0, 0, 237, 238, 5,
        77, 0, 0, 238, 239, 5, 69, 0, 0, 239, 51, 1, 0, 0, 0, 240, 241, 5, 77, 0, 0, 241, 242, 5, 46, 0,
        0, 242, 243, 5, 67, 0, 0, 243, 244, 1, 0, 0, 0, 244, 245, 3, 90, 44, 0, 245, 246, 5, 46, 0, 0,
        246, 247, 5, 84, 0, 0, 247, 248, 5, 46, 0, 0, 248, 249, 5, 78, 0, 0, 249, 250, 5, 65, 0, 0, 250,
        251, 5, 77, 0, 0, 251, 252, 5, 69, 0, 0, 252, 53, 1, 0, 0, 0, 253, 254, 5, 77, 0, 0, 254, 255,
        5, 46, 0, 0, 255, 256, 5, 67, 0, 0, 256, 257, 1, 0, 0, 0, 257, 258, 3, 90, 44, 0, 258, 259, 5,
        46, 0, 0, 259, 260, 5, 80, 0, 0, 260, 261, 5, 46, 0, 0, 261, 262, 5, 78, 0, 0, 262, 263, 5, 65,
        0, 0, 263, 264, 5, 77, 0, 0, 264, 265, 5, 69, 0, 0, 265, 55, 1, 0, 0, 0, 266, 267, 5, 79, 0, 0,
        267, 268, 5, 46, 0, 0, 268, 269, 5, 83, 0, 0, 269, 270, 5, 46, 0, 0, 270, 271, 1, 0, 0, 0, 271,
        272, 3, 88, 43, 0, 272, 57, 1, 0, 0, 0, 273, 274, 5, 79, 0, 0, 274, 275, 5, 46, 0, 0, 275, 276,
        5, 67, 0, 0, 276, 277, 1, 0, 0, 0, 277, 278, 3, 90, 44, 0, 278, 279, 5, 46, 0, 0, 279, 280, 5,
        78, 0, 0, 280, 281, 5, 65, 0, 0, 281, 282, 5, 77, 0, 0, 282, 283, 5, 69, 0, 0, 283, 59, 1, 0, 0,
        0, 284, 285, 5, 79, 0, 0, 285, 286, 5, 46, 0, 0, 286, 287, 5, 67, 0, 0, 287, 288, 1, 0, 0, 0,
        288, 289, 3, 90, 44, 0, 289, 290, 5, 46, 0, 0, 290, 291, 5, 84, 0, 0, 291, 292, 5, 46, 0, 0,
        292, 293, 5, 78, 0, 0, 293, 294, 5, 65, 0, 0, 294, 295, 5, 77, 0, 0, 295, 296, 5, 69, 0, 0, 296,
        61, 1, 0, 0, 0, 297, 298, 5, 79, 0, 0, 298, 299, 5, 46, 0, 0, 299, 300, 5, 67, 0, 0, 300, 301,
        1, 0, 0, 0, 301, 302, 3, 90, 44, 0, 302, 303, 5, 46, 0, 0, 303, 304, 5, 80, 0, 0, 304, 305, 5,
        46, 0, 0, 305, 306, 5, 78, 0, 0, 306, 307, 5, 65, 0, 0, 307, 308, 5, 77, 0, 0, 308, 309, 5, 69,
        0, 0, 309, 63, 1, 0, 0, 0, 310, 312, 5, 45, 0, 0, 311, 310, 1, 0, 0, 0, 311, 312, 1, 0, 0, 0,
        312, 314, 1, 0, 0, 0, 313, 315, 3, 92, 45, 0, 314, 313, 1, 0, 0, 0, 315, 316, 1, 0, 0, 0, 316,
        314, 1, 0, 0, 0, 316, 317, 1, 0, 0, 0, 317, 324, 1, 0, 0, 0, 318, 320, 5, 46, 0, 0, 319, 321, 3,
        92, 45, 0, 320, 319, 1, 0, 0, 0, 321, 322, 1, 0, 0, 0, 322, 320, 1, 0, 0, 0, 322, 323, 1, 0, 0,
        0, 323, 325, 1, 0, 0, 0, 324, 318, 1, 0, 0, 0, 324, 325, 1, 0, 0, 0, 325, 65, 1, 0, 0, 0, 326,
        328, 7, 1, 0, 0, 327, 326, 1, 0, 0, 0, 328, 329, 1, 0, 0, 0, 329, 327, 1, 0, 0, 0, 329, 330, 1,
        0, 0, 0, 330, 331, 1, 0, 0, 0, 331, 332, 6, 32, 2, 0, 332, 67, 1, 0, 0, 0, 333, 334, 5, 44, 0,
        0, 334, 69, 1, 0, 0, 0, 335, 336, 5, 61, 0, 0, 336, 71, 1, 0, 0, 0, 337, 338, 5, 59, 0, 0, 338,
        73, 1, 0, 0, 0, 339, 340, 5, 39, 0, 0, 340, 75, 1, 0, 0, 0, 341, 342, 5, 34, 0, 0, 342, 77, 1,
        0, 0, 0, 343, 344, 5, 91, 0, 0, 344, 79, 1, 0, 0, 0, 345, 346, 5, 93, 0, 0, 346, 81, 1, 0, 0, 0,
        347, 348, 5, 40, 0, 0, 348, 83, 1, 0, 0, 0, 349, 350, 5, 41, 0, 0, 350, 85, 1, 0, 0, 0, 351,
        355, 5, 34, 0, 0, 352, 354, 8, 2, 0, 0, 353, 352, 1, 0, 0, 0, 354, 357, 1, 0, 0, 0, 355, 353, 1,
        0, 0, 0, 355, 356, 1, 0, 0, 0, 356, 358, 1, 0, 0, 0, 357, 355, 1, 0, 0, 0, 358, 359, 5, 34, 0,
        0, 359, 87, 1, 0, 0, 0, 360, 362, 7, 3, 0, 0, 361, 360, 1, 0, 0, 0, 362, 363, 1, 0, 0, 0, 363,
        361, 1, 0, 0, 0, 363, 364, 1, 0, 0, 0, 364, 89, 1, 0, 0, 0, 365, 369, 7, 4, 0, 0, 366, 368, 3,
        92, 45, 0, 367, 366, 1, 0, 0, 0, 368, 371, 1, 0, 0, 0, 369, 367, 1, 0, 0, 0, 369, 370, 1, 0, 0,
        0, 370, 91, 1, 0, 0, 0, 371, 369, 1, 0, 0, 0, 372, 373, 7, 5, 0, 0, 373, 93, 1, 0, 0, 0, 11, 0,
        1, 102, 311, 316, 322, 324, 329, 355, 363, 369, 3, 5, 1, 0, 4, 0, 0, 6, 0, 0,
    ];
    static __ATN;
    static get _ATN() {
        if (!AioExpressionLexer.__ATN) {
            AioExpressionLexer.__ATN = new ATNDeserializer().deserialize(AioExpressionLexer._serializedATN);
        }
        return AioExpressionLexer.__ATN;
    }
    static DecisionsToDFA = AioExpressionLexer._ATN.decisionToState.map((ds, index) => new DFA(ds, index));
}
